// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"fddff1f5","743":"ce5d80eb","917":"3411465f"}[chunkId] + ".chunk.js";
};